import { FC } from 'react';
import { AnalyticsCommonTypes } from '@frontend/api-analytics';
import { GroupedChecklistChipDropdownMenu } from '@frontend/call-intel-core';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../../../../tracking-ids';
import { useVoiceAiLocations } from '../../../hooks/use-voice-ai-locations';
import { FilterIcon } from '../../atoms/filter-icon';
import { useCallIntelFiltersContext } from '../../context/call-intel-filters.context';
import { useOfficeUserFilterData } from './use-office-user-filter-data';

export interface OfficeUserFilterChipProps {
  disabled?: boolean;
  officeUsers?: AnalyticsCommonTypes.StringRecord;
}

export const OfficeUserFilterChip: FC<OfficeUserFilterChipProps> = ({ disabled, officeUsers }) => {
  const { t } = useTranslation('call-intelligence');
  const { filterValues } = useCallIntelFiltersContext();

  const { activeLocationIds: activeVoiceAiLocations, isLoading: isVoiceAiLoading } = useVoiceAiLocations({
    locationIds: filterValues.locations ?? [],
  });

  const {
    value: selectedValues,
    defaultValue,
    groupedOfficeUsers,
    hasOptions,
    isLoading,
    onChange,
  } = useOfficeUserFilterData({ officeUsers, showAiReceptionist: activeVoiceAiLocations.length > 0 });

  const isDisabled = disabled || isLoading || isVoiceAiLoading;

  if (!hasOptions) {
    return null;
  }

  return (
    <div data-testid='office-user-filter-chip'>
      <GroupedChecklistChipDropdownMenu
        customStyles={{ chipDropdownFilter: { width: '100%' } }}
        defaultValue={defaultValue}
        label={t('Office User')}
        onChange={onChange}
        groups={groupedOfficeUsers}
        renderIcon={(isFilterActive) => <FilterIcon name='user-small' isFilterActive={isFilterActive} />}
        trackingId={trackingIds.callIntel.officeUsersSelector}
        value={selectedValues}
        disabled={isDisabled}
      />
    </div>
  );
};
